import React, {useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import TabsNav from '../../../components/tabsNav/Tabs';
import {t} from 'react-switch-lang';
import FindingsCompleted from './findingsComponents/FindingsCompleted';


const Findings = () => {
  const [activeTab, setActiveTab] = useState('COMPLETED');

  return(
    <>
        <Row className="mx-5 py-5 findingsTable">
          <Row className="findingsTableHeader m-0">
            <Col xs="12" md="8" className="text-left pr-0 pl-0">
              <TabsNav
                items={[
                  {
                    name: t('dashboard.tabsNav.finished'),
                    target: 'COMPLETED',
                  },
                  {
                    name: t('dashboard.tabsNav.partially-completed'),
                    target: 'PARTIALLY_COMPLETED',
                  },
                  {
                    name: t('dashboard.tabsNav.unfinished'),
                    target: 'INCOMPLETE',
                  },
                  {
                    name: t('dashboard.tabsNav.continuously'),
                    target: 'CONTINUOUS',
                  },
                  {
                    name: t('dashboard.tabsNav.inProgress'),
                    target: 'IN_PROGRESS',
                  },
                  {
                    name: t('dashboard.tabsNav.givingUp'),
                    target: 'ABORTED',
                  },
                ]}
                textProperty="name"
                itemValue="target"
                selectedItem={activeTab}
                onItemSelect={setActiveTab}
                classes="tabs-nav-findings"
              />
            </Col>
          </Row>
          <Row className="mt-3">
            {activeTab === 'COMPLETED' && <FindingsCompleted  activeTab={activeTab}/> }
            {activeTab === 'PARTIALLY_COMPLETED' && <FindingsCompleted  activeTab={activeTab}/> }
            {activeTab === 'INCOMPLETE' && <FindingsCompleted  activeTab={activeTab}/> }
            {activeTab === 'CONTINUOUS' && <FindingsCompleted  activeTab={activeTab}/> }
            {activeTab === 'IN_PROGRESS' && <FindingsCompleted  activeTab={activeTab}/> }
            {activeTab === 'ABORTED' && <FindingsCompleted  activeTab={activeTab}/> }
          </Row>
          </Row>
      </>
  )

}
export default Findings;